import loadable from "@loadable/component";
import { ErrorBoundary } from "../../../components";
import FullPageLoader from "@Components/FullPageLoader";

const AmberUserServiceAgreementDesktop = loadable(() => import("./AmberUserServiceAgreement"), {
  fallback: <FullPageLoader />,
});

export default (props: any): JSX.Element => (
  <ErrorBoundary>
    <AmberUserServiceAgreementDesktop {...props} />
  </ErrorBoundary>
);
